import { Link } from "react-router-dom";
import { extras } from "@/mocks/manga";

const icons = ["ri-gift-line", "ri-heart-pulse-line", "ri-cake-3-line", "ri-cup-line"];

export default function Extras() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">番外收录</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              甜蜜惩罚漫画番外专题
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              正篇之外的甜蜜补充，新婚篇、童年篇、情人节篇等番外完整收录，与正篇分开整理。
            </p>
          </div>
          <Link
            to="/catalog"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部番外
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {extras.map((c, i) => (
            <Link
              key={c.id}
              to={`/read/${c.id}`}
              className="group relative overflow-hidden rounded-2xl bg-background-100 p-6 transition-colors hover:bg-accent-100/60"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className={`${icons[i % icons.length]} text-2xl`}></i>
              </span>
              <span className="mt-4 inline-block rounded-full bg-primary-100 px-3 py-1 text-[10px] font-semibold text-primary-700">
                番外
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                {c.title.replace("番外 · ", "")}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}